var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClaimed = function SvgClaimed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1.1rem",
    viewBox: "0 0 20 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.374.6A2.47 2.47 0 0 1 11.6.598l7.511 6.431c.563.482.889 1.192.889 1.941v11.055a1.99 1.99 0 0 1-.57 1.397 1.93 1.93 0 0 1-1.374.578H1.944C.871 22 0 21.116 0 20.025V8.968c0-.747.324-1.456.886-1.939L8.374.6zm2.152 1.292a.824.824 0 0 0-1.076 0l-7.489 6.43a.852.852 0 0 0-.294.646v11.057a.28.28 0 0 0 .277.283h16.112a.28.28 0 0 0 .277-.283V8.97a.852.852 0 0 0-.296-.647l-7.511-6.431v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.203 9.832a.853.853 0 0 1 0 1.197L9.2 16.11a.824.824 0 0 1-1.178 0L5.8 13.853a.855.855 0 0 1-.24-.828.84.84 0 0 1 .602-.61.825.825 0 0 1 .816.242l1.633 1.66 4.415-4.485a.824.824 0 0 1 1.177 0z"
  }))));
};
export default SvgClaimed;